export default __webpack_public_path__ + "static/media/signup_img.4e055a64.jpg";